export default "__VITE_ASSET__BMd6U6Js__"